<template>
  <div>
    <v-fab-transition>
      <v-btn color="primary" dark fab fixed bottom right v-if="showButton" @click="backTop" :class="fabClass">
        <v-icon>mdi-arrow-up</v-icon>
      </v-btn>
    </v-fab-transition>
  </div>
</template>

<script>
import { scrollTop } from '@/utils'
export default {
  methods: {
    backTop() {
      const sTop = document.documentElement.scrollTop || document.body.scrollTop
      scrollTop(window, sTop, 0, 1000)
    }
  },
  computed: {
    fabClass() {
      if (this.$store.state.user.rptJob.rptProcess.show) {
        return 'fabClass'
      } else {
        return ''
      }
    }
  },
  props: {
    showButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.fabClass.btn--bottom {
  bottom: 70px;
}
</style>
